<template>
  <div class="modal-box">
    <div class="modal-title">
      <h3>Bewerk klant
      </h3>
      <div class="flex-divider"></div>
      <base-button
        type="secondary"
        @click="closeModal"
      >
        <base-icon iconRef="close" />
      </base-button>
    </div>
    <div class="modal-content">
      <div class="modal-content-section">
        <div class="input-header">
          <h4>Basisgegevens</h4>
        </div>
        <div class="input-container">
          <label
            class="label required"
            for="clientName"
          >Klantnaam</label>
          <base-input
            id="clientName"
            name="clientName"
            type="text"
            v-model="clientBody.clientName"
            data-vv-as="Klantnaam"
            v-validate="'required'"
          />
          <base-input-warning :error="errors.first('clientName')" />
        </div>
        <div class="input-container">
          <label
            for
            class="label"
          >Beschrijving</label>
          <textarea
            class="input"
            v-model="clientBody.description"
          ></textarea>
        </div>
        <div class="input-container">
          <label class="label required">Sales eigenaar</label>
          <select
            class="input"
            name="salesOwner"
            id="salesOwner"
            v-model="clientBody.salesOwner"
            data-vv-as="Sales eigenaar"
            v-validate="'required'"
          >
            <option
              :value="username"
              v-for="username in usersNames"
              :key="username"
            >{{username}}</option>
          </select>
          <base-input-warning :error="errors.first('salesOwner')" />
        </div>
      </div>
      <div class="modal-content-section">
        <div class="input-header">
          <h4>Contactpersoon</h4>
        </div>
        <div class="input-row">
          <div class="input-container">
            <label
              class="label"
              for="contactFirstName"
            >Voornaam</label>
            <base-input
              id="contactFirstName"
              name="contactFirstName"
              type="text"
              v-model="clientBody.contactFirstName"
            />
          </div>
          <div class="input-container">
            <label
              class="label"
              for="contactLastName"
            >Achternaam</label>
            <base-input
              id="contactLastName"
              name="contactLastName"
              type="text"
              v-model="clientBody.contactLastName"
            />
          </div>
        </div>
        <div class="input-container">
          <label class="label">E-mail</label>
          <base-input
            type="email"
            v-model="clientBody.contactEmail"
          />
        </div>
        <div class="input-container">
          <label class="label">Telefoonnummer</label>
          <base-input
            type="tel"
            v-model="clientBody.contactTel"
          />
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <base-button
        @click="deleteClient"
        type="danger"
        :loading="deletingClient"
        :disabled="deletingClient || editingClient"
      >Verwijderen</base-button>
      <div class="flex-divider"></div>
      <base-button
        @click="closeModal"
        type="secondary"
      >Annuleren</base-button>
      <base-button
        @click="editClient"
        :loading="editingClient"
        :disabled="editingClient || deletingClient"
      >
        <base-icon
          iconRef="save"
          position="left"
        />Opslaan
      </base-button>
    </div>
  </div>
</template>

<script>
import Firebase from "firebase";

export default {
  name: "client-edit-modal",
  data: function() {
    return {
      deletingClient: false,
      editingClient: false,
      clientBody: {
        clientName: "",
        description: "",
        contactFirstName: "",
        contactLastName: "",
        contactEmail: "",
        contactTel: "",
        salesOwner: ""
      }
    };
  },
  computed: {
    currentClient: function() {
      return this.$store.getters.getCurrentClientPage.client;
    },
    usersList: function() {
      return this.$store.getters.getUsersList;
    },
    usersNames: function() {
      const usersNames = [];
      this.usersList
        .filter(user => {
          return user.data().includeInMeasurements;
        })
        .forEach(user => {
          usersNames.push(user.data().firstName + " " + user.data().lastName);
        });
      return usersNames;
    }
  },
  methods: {
    editClient: function() {
      this.$validator.validate().then(result => {
        if (result) {
          this.editingClient = true;
          const clientData = {
            id: this.currentClient.id,
            body: this.$editClientDataObject(this.clientBody)
          };
          Firebase.firestore()
            .collection("clients")
            .doc(clientData.id)
            .update(clientData.body)
            .then(() => {
              Firebase.firestore()
                .collection("clients")
                .doc(clientData.id)
                .get()
                .then(doc => {
                  this.$store.commit("setCurrentClientPageClient", doc);
                  this.editingClient = false;
                  this.closeModal();
                });
            });
        }
      });
    },
    deleteClient: function() {
      this.$dialog.confirm({
        message: `Weet je zeker dat je de klant:
        <p class="dialog-attention">${this.currentClient.data().clientName}</p>
        wilt verwijderen?`,
        cancelText: "Annuleer",
        confirmText: "Verwijder",
        type: "is-danger",
        onConfirm: () => {
          this.deletingClient = true;
          const clientData = {
            id: this.currentClient.id,
            body: this.$deleteClientDataObject()
          };
          this.$store.dispatch("editClient", clientData).then(() => {
            this.deletingClient = false;
            this.closeModal();
            this.$router.push("/klanten");
          });
        }
      });
    },
    closeModal: function() {
      this.$store.commit("setModalShown", {
        dataType: "client",
        modalType: "edit",
        shown: false
      });
    }
  },
  mounted: function() {
    this.clientBody = Object.assign({}, this.currentClient.data());
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modal-components/client-edit-modal.vue